import { DataFormCarroselBannersProps } from 'types/DataFormCarroselBannersProps';

export function verifyIfFormCanSave(
	dataForm: DataFormCarroselBannersProps,
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.title === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Título"');
		return;
	}

	if (dataForm.type === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Tipo"');
		return;
	}

	if (dataForm.banners.length === 0) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Cadastre pelo menos 1 banner');
		return;
	}

	// if (dataForm.schedule?.start !== '' && dataForm.schedule?.end === '') {
	// 	setCanSaveModuleOnBack(false);
	// 	setMessageErrorForm('Se preencheu a data incial, preenha a data final.');
	// 	return;
	// }

	// if (dataForm.schedule?.end !== '' && dataForm.schedule?.start === '') {
	// 	setCanSaveModuleOnBack(false);
	// 	setMessageErrorForm('Se preencheu a data final, preenha a data inicial.');
	// 	return;
	// }

	if (
		dataForm.schedule &&
		new Date(dataForm.schedule?.start) > new Date(dataForm.schedule?.end)
	) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data inicial não pode ser depois da data final');
		return;
	}

	if (
		dataForm.schedule &&
		new Date(dataForm.schedule?.end) < new Date(dataForm.schedule?.start)
	) {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('A data final não pode ser antes da data inicial');
		return;
	}

	setCanSaveModuleOnBack(true);
}
